export const NEW_MIGRATION_FORM = "configNewMigrationForm";